module.exports = __webpack_public_path__ + "img/logo.ab5bb01e.svg";